import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { AnimationBase } from '../animation-base';

@Component({
  selector: 'mdw-slide',
  templateUrl: './slide.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./slide.scss'],
})
export class MdwSlide extends AnimationBase {
  public readonly isActive = input.required<boolean>();
  public readonly direction = input<'forward' | 'backward'>();

  protected readonly enterClass = computed(() =>
    this.direction() === 'backward' ? 'enter-from-left' : 'enter-from-right',
  );

  protected readonly leaveClass = computed(() =>
    this.direction() === 'backward' ? 'leave-to-right' : 'leave-to-left',
  );
}
